/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_How_We_Work_TitleInputs */

const en_meta_how_we_work_title = /** @type {(inputs: Meta_How_We_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How an AI automation project runs | Lindevo`)
};

const lv_meta_how_we_work_title = /** @type {(inputs: Meta_How_We_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā noris AI automatizācijas projekts | Lindevo`)
};

/**
* | output |
* | --- |
* | "How an AI automation project runs \| Lindevo" |
*
* @param {Meta_How_We_Work_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_how_we_work_title = /** @type {((inputs?: Meta_How_We_Work_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_How_We_Work_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_how_we_work_title(inputs)
	return en_meta_how_we_work_title(inputs)
});